import { PageComponent } from '@root/pages/Type';
import ItemSkeleton from './ItemSkeleton';
import styles from './style.module.scss';

const LoadingList: PageComponent = () => {
    return (
        <div className={styles.service_list}>
            {Array(3)
                .fill(1)
                .map((service) => (
                    <ItemSkeleton key={`server-${service}`} index={service.toString()} />
                ))}
        </div>
    );
};

export default LoadingList;
